//Item active in navbar
if (/rejoignez-nous/.test(window.location.href)) {
    document.querySelectorAll('#joinus').forEach(element => element.classList.add('active'));
} else if (window.location.href.indexOf("services/offres") > -1) {
    document.querySelectorAll('#joinus').forEach(element => element.classList.add('active'));
} else if (/contact/.test(window.location.href)) {
    document.querySelectorAll('#contact').forEach(element => element.classList.add('active'));
} else if (/dossiers/.test(window.location.href)) {
    document.querySelectorAll('#services').forEach(element => element.classList.add('active'));
} else if (/activites/.test(window.location.href)) {
    document.querySelectorAll('#services').forEach(element => element.classList.add('active'));
} else if (/services/.test(window.location.href)) {
    document.querySelectorAll('#services').forEach(element => element.classList.add('active'));
} else if (window.location.href.indexOf("/") > -1) {
    document.querySelectorAll('#home').forEach(element => element.classList.add('active'));
}
